var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuOpenDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34863",
    "data-name": "Rectangle 34863",
    width: 24,
    height: 24,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_7874",
    "data-name": "Mask Group 7874",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_64",
    "data-name": "Union 64",
    d: "M22849.916,12199.411a.889.889,0,0,1-.787-.5,1.1,1.1,0,0,1,0-1,.889.889,0,0,1,.787-.5h20.186a.9.9,0,0,1,.787.5,1.1,1.1,0,0,1,0,1,.9.9,0,0,1-.787.5Zm0-6a.89.89,0,0,1-.787-.5,1.1,1.1,0,0,1,0-1,.89.89,0,0,1,.787-.5h20.186a.9.9,0,0,1,.787.5,1.1,1.1,0,0,1,0,1,.9.9,0,0,1-.787.5Zm0-6a.89.89,0,0,1-.787-.5,1.111,1.111,0,0,1,0-1,.9.9,0,0,1,.787-.5h20.186a.914.914,0,0,1,.787.5,1.111,1.111,0,0,1,0,1,.9.9,0,0,1-.787.5Z",
    transform: "translate(-22848.008 -12180.411)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOpenDark);
export default __webpack_public_path__ + "static/media/menuOpenDark.82a2f2d7b96033cb17c8e8d412bba421.svg";
export { ForwardRef as ReactComponent };